export default __webpack_public_path__ + "static/media/12_bathroom.33d7f671.png";